import Vue from 'vue'
import VueRouter from 'vue-router'

// https://github.com/declandewet/vue-meta
import VueMeta from 'vue-meta'
// Adds a loading bar at the top during page loads.
import NProgress from 'nprogress/nprogress'
import store from '@state/store'
import routes from './routes'
import { fetchUserPermissions } from '../helpers/http';
import { hasWritePermission } from '../helpers/rulesToken';
import AuthService from '../services/auth.service';

Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'metaInfo',
})

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// Проверка авторизованности пользователя перед каждым переходом в роуте
export const loginResolver = async(routeTo, routeFrom, next) => {
  await store.dispatch('auth/fetchAppSettings');
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  if (!authRequired) {
    return Promise.resolve();
  }
  try {
    await store.dispatch('site/getSiteList');
  } catch (e) {
    next({ name: 'login' })
  }

  if (!store.getters['site/loggedIn']) {
    return next({ name: 'login' });
  }

  if ('authPermission' in routeTo.meta) {
    const permission = routeTo.meta.authPermission;
    let userPermission = true;

    if (permission === 'write') {
      userPermission = hasWritePermission();
    } else {
      userPermission = fetchUserPermissions()[permission];
    }

    if (!userPermission) {
      next({ name: '404' })
    }
  }

  if (routeTo.name === 'index') {
    let site = localStorage.getItem('site')
    if (store.getters['site/siteList'].length === 1) {
      next({
        name: 'builds',
        params: {
          project: store.getters['site/siteList'][0].name
        }
      })
    } else if (site && store.getters['site/siteList'].find(val => val.name === site)) {
      next({
        name: 'builds',
        params: {
          project: site
        }
      })
    }
  } else if (routeTo.params.project && !store.getters['site/siteList'].find(val => val.name === routeTo.params.project)) {
    next({ name: '404' })
  }

  return Promise.resolve()
}

router.beforeEach((routeTo, routeFrom, next) => {
  if (routeFrom.name !== null && routeFrom.name !== routeTo.name) {
    NProgress.start();
  }

  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  if (authRequired && !AuthService.isAuthorized()) {
    next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
    return;
  }

  if (routeTo.matched.some(route => route.meta.skipAuthorized) && AuthService.isAuthorized()) {
    next({ name: 'index' });

    return;
  }

  next();
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    await loginResolver(routeTo, routeFrom, next)
  } catch (error) {
    return
  }

  // If we reach this point, continue resolving the route.
  next()
})

router.afterEach((routeTo, routeFrom) => {
  NProgress.done()
})

export default router
